import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // Only redirect if not already on login or signup page
      const currentPath = window.location.pathname;
      if (currentPath !== "/login" && currentPath !== "/signup") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  signup: async (email, password, name) => {
    const response = await api.post("/auth/signup", { email, password, name });
    return response.data;
  },
  login: async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    return response.data;
  },
};

export const licenseAPI = {
  getAll: async () => {
    const response = await api.get("/license");
    return response.data;
  },

  getById: async (licenseId) => {
    const response = await api.get(`/license/${licenseId}`);
    return response.data;
  },

  generate: async (data) => {
    const response = await api.post("/license/generate", data);
    return response.data;
  },

  revoke: async (licenseId, reason) => {
    const response = await api.post(`/license/${licenseId}/revoke`, { reason });
    return response.data;
  },

  renew: async (licenseId, data) => {
    const response = await api.post(`/license/${licenseId}/renew`, data);
    return response.data;
  },

  health: async () => {
    const response = await api.get("/license/health");
    return response.data;
  },
};

export const customerAPI = {
  getAll: async (page = 1, limit = 20, search = '') => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    
    const response = await api.get(`/customer?${params}`);
    return response.data;
  },

  getById: async (customerId) => {
    const response = await api.get(`/customer/${customerId}`);
    return response.data;
  },

  getLicenses: async (customerId) => {
    const response = await api.get(`/customer/${customerId}/licenses`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post("/customer", data);
    return response.data;
  },

  update: async (customerId, data) => {
    const response = await api.put(`/customer/${customerId}`, data);
    return response.data;
  },

  delete: async (customerId) => {
    const response = await api.delete(`/customer/${customerId}`);
    return response.data;
  },
};

export const errorLogAPI = {
  getAll: async (page = 1, limit = 50, licenseId) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (licenseId) params.append("licenseId", licenseId.toString());

    const response = await api.get(`/error-logs?${params}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get("/error-logs/stats");
    return response.data;
  },
};

export default api;
